// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  locationTypes: [],
}

export const mutations = {
  SET_LOCATION_TYPES(state, locationTypes) {
    state.locationTypes = locationTypes
  },
}

export const actions = {
  fetchLocationTypes({ commit }, payload) {
    return ApiService.fetchLocationTypes(payload)
      .then((res) => {
        const locationTypes = res.data.data
        commit('SET_LOCATION_TYPES', locationTypes)
      })
      .catch((error) => {
        throw error
      })
  },
}
